import script from "./TableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=2e1875f0&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1875f0"]])

export default __exports__